import { Component } from '@angular/core';
import { BaseDialogComponent } from '../base-dialog/base-dialog.component';
import { ReportDateService } from 'src/app/services/report-date.service';

/**
 * Sets, changes or clears the date a gift certificate's email goes out.
 *
 * Complements the same option on the issuance wizard for certificates that
 * already exist. Cron delivers on the chosen day (08:00 studio time); an
 * already-delivered certificate cannot be scheduled again. Resend Email
 * covers that.
 */
@Component({
  selector: 'app-schedule-gift-certificate-email-dialog',
  templateUrl: './schedule-gift-certificate-email-dialog.component.html',
  styleUrls: ['./schedule-gift-certificate-email-dialog.component.css']
})
export class ScheduleGiftCertificateEmailDialogComponent extends BaseDialogComponent {
  certificate: any;
  sendDate: Date | null = null;
  minDate = new Date();
  saving = false;

  private _reportDateService: ReportDateService;
  get reportDateService(): ReportDateService {
    if (!this._reportDateService) {
      this._reportDateService = ReportDateService.shared(this._studioConfigService);
    }
    return this._reportDateService;
  }

  override ngOnInit() {
    this.certificate = this._injectedDialogData?.data?.certificate ?? {};
    if (this.certificate.field_email_send_date) {
      // A date-only value; build local midnight so the picker shows the same day.
      const [y, m, d] = String(this.certificate.field_email_send_date).slice(0, 10).split('-').map(Number);
      this.sendDate = new Date(y, m - 1, d);
    }
  }

  get alreadySent(): boolean {
    return !!this.certificate?.email_sent_date;
  }

  get canSave(): boolean {
    return !this.alreadySent && !!this.sendDate && !this.saving;
  }

  save() {
    this.apply(this.reportDateService.formatCalendarParam(this.sendDate));
  }

  clear() {
    this.apply(null);
  }

  private apply(sendDate: string | null) {
    this.saving = true;
    this._entityRESTService.patchEntity('gift_certificates', 'gift_certificate', this.certificate.id, {
      field_email_send_date: sendDate,
    }).subscribe(
      () => {
        this.saving = false;
        this._snackBar.open(sendDate ? `Email scheduled for ${this.reportDateService.formatDate(sendDate)}.` : 'Scheduled email cleared.', 'Close', { duration: 5000 });
        this._dialogRef.close({ saved: true });
      },
      (error) => {
        this.saving = false;
        this.handleError(error);
      }
    );
  }
}
